<router-outlet></router-outlet>
<app-toasts></app-toasts>
